<template>
  <div>
    <b-modal title="Calcular parcelas" ref="modal">
      <div class="row">
        <div class="col-12">
          <number-input v-model="form.total.value" alias="Valor" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <number-input
            v-model="form.quantity.value"
            :decimal-places="0"
            :minimumValue="-999999999"
            alias="Quantidade de Parcelas"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <date-input v-model="form.first_due_date.value" alias="Primeiro Vencimento (Opcional)" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <number-input
            v-model="form.days_interval.value"
            :decimal-places="0"
            :currencySymbol="' Dias'"
            :minimumValue="-999999999"
            alias="Intervalo entre parcelas"
          />
        </div>
      </div>

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="setParcels()">
          <i class="fas fa-check"></i> Gerar parcelas
        </button>
        <!-- <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar e adicionar outro
        </button>-->
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import moment from "moment";

export default {
  data() {
    return {
      form: new Form({
        total: {
          value: null
        },

        days_interval: {
          value: null
        },

        first_due_date: {
          value: null
        },

        quantity: {
          value: 1
        }
      }),

      parcels: [
        {
          value_parcel: null,

          due_date: null
        }
      ]
    };
  },

  watch: {
    parcels: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  },

  computed: {
    parcelValue() {
      if (this.form.quantity.value > 0) {
        return (
          Math.round((this.form.total.value / this.form.quantity.value) * 100) /
          100
        );
      }
      return 0;
    },

    restValue() {
      return (
        Math.round(
          (this.form.total.value -
            this.parcelValue * this.form.quantity.value) *
            100
        ) / 100
      );
    }
  },

  methods: {
    open() {
      this.$refs.modal.show();
    },

    calcParcels() {
      let parcels = [];

      for (
        var parcelNumber = 1;
        parcelNumber <= this.form.quantity.value;
        parcelNumber++
      ) {
        parcels.push(this.calcParcel(parcelNumber));
      }

      return parcels;
    },

    calcParcel(parcelNumber) {
      let parcel = {};

      parcel.value = this.getParcelValue(parcelNumber);
      parcel.days = this.getParcelDays(parcelNumber);
      parcel.due_date = this.getParcelDueDate(parcelNumber);

      return parcel;
    },

    getParcelValue(parcelNumber) {
      if (parcelNumber == 1) {
        return this.parcelValue + this.restValue;
      }
      return this.parcelValue;
    },

    getParcelDays(parcelNumber) {
      return parcelNumber * this.form.days_interval.value;
    },

    getParcelDueDate(parcelNumber) {

      let due_date = moment(this.form.first_due_date.value);

      if (this.form.first_due_date.value != null) {

       return moment(due_date)
          .add(parcelNumber * this.form.days_interval.value - this.form.days_interval.value, "d")
          .format("YYYY-MM-DD");

      } else {
        return moment({
          h: 0,
          m: 0,
          s: 0,
          ms: 0
        })
          .add(parcelNumber * this.form.days_interval.value, "d")
          .format("YYYY-MM-DD");
      }
    },

    setParcels() {
      this.$emit("parcels", this.calcParcels());
      this.$refs.modal.hide();
    }
  }
};
</script>

<style>
</style>
